import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ErrorService, LayoutService } from '@core/services';
import { LeaveAdminStoreService } from '@core/services/leave-admin-store.service';
import { LeaveAdminService } from '@core/services/leave-admin.service';
import { UnsavedChangesComponent } from '../unsaved-changes/unsaved-changes.component';
import { Subject, Observable } from 'rxjs';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';
import { PostActionItemCheckedOnDate, StiiraError } from '@core/models';
import { indicate, keepDialogOpen } from '@shared/helpers';

@Component({
    selector: 'app-edit-checked-on',
    templateUrl: './edit-checked-on.component.html',
    styleUrl: './edit-checked-on.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditCheckedOnComponent {
  static readonly componentName = 'EditCheckedOnComponent';
  
  public form: UntypedFormGroup;
  public isSubmitting$: Subject<boolean> = new Subject<boolean>();
  public position = position;
  public onDragEnded = onDragEnded;
  public sysText: any;

  private formInitValues: any;

  public isMobile$: Observable<boolean>;

  get noChanges(): boolean {
    return JSON.stringify(this.form.value) === JSON.stringify(this.formInitValues);
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      actionId: number;
      checkedOnDate: Date
    },
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<EditCheckedOnComponent>,
    private dialog: MatDialog,
    private layoutService: LayoutService,
    private errorService: ErrorService,
    private service: LeaveAdminService,
    private store: LeaveAdminStoreService,
  ) { 
    this.form = this.fb.group({
      date: new FormControl(null),
    });
  }

  ngOnInit(): void {
    this.isMobile$ = this.layoutService.isMobile$();

    this.sysText = this.store.sysText[this.store.templates.actionItems];

    this.form.patchValue({
      date: this.data.checkedOnDate
    });

    this.formInitValues = { ...this.form.value };
  }

  public onSubmit(): void {
    const dto: PostActionItemCheckedOnDate = {
      caseId: this.store.caseDetails.leaveInformation.caseId,
      actionItemId: this.data.actionId,
      date: this.form.controls.date.value
    }
    this.service.postEditActionItemCheckedOnDate(dto)
      .pipe(
        indicate(this.isSubmitting$),
        keepDialogOpen(this.dialogRef)
      )
      .subscribe((res) => {
          this.store.caseDetails = res;
          this.dialogRef.close();
        }, (err: StiiraError) => {
          this.errorService.setFormModelStateErrors(this.form, err.modelStateErrors);
        }
      );
  }

  public close(canNavigate: boolean): void {
    if (canNavigate) {
      this.dialogRef.close();
    } else {
      if (this.noChanges) {
        this.dialogRef.close();
      } else {
        this.openUnsavedChangesDialog();
      }
    }
  }

  private openUnsavedChangesDialog(): void {
    const dialogConfig: MatDialogConfig = {
      id: UnsavedChangesComponent.componentName,
      width: '300px',
      data: this.store.sysText[this.store.templates.unsavedChanges]
    };
    
    this.dialog.open(UnsavedChangesComponent, dialogConfig)
      .afterClosed().subscribe((res: boolean) => {
        if (res) {
          this.dialogRef.close();
        }
      });
  }
}